export const reattributionSubStr = 'reattribution_callback=appnext_install%26clickid%3Dxapnt1x';

export const reattribution = ['reattribution_callback', 'appnext_install&clickid=xapnt1x'];

export const fieldConvert = {
  deeplink: 'Deep_Link',
  impression: 'Impression_Link',
  tracking: 'Tracking_Link',
  vta: 'VTA_Link',
};
